module.exports = __webpack_public_path__ + "img/ExitusMujer-Calle@2x.25b1357f.png";